import {load} from '@shopify/theme-sections';

import '../sections/hero-slider';
import '../sections/featured-collection';
import '../sections/featured-media';
import '../sections/featured-products';
import '../sections/featured-awards';
import '../sections/featured-carousel';
import '../sections/featured-expert-video';
import '../sections/image-banner';
import '../sections/image-columns';
import '../sections/images-row';
import '../sections/grid-cta';
import '../sections/quotes-carousel';
import '../sections/before-after';
import initShareToggle from '../components/social-share';

document.addEventListener('DOMContentLoaded', () => {
  load('*');

  initShareToggle();
});
